import type { DecoderFunction } from '@df/common';
import { z } from 'zod';

export type { DecoderFunction };

/**
 * Adapts a Zod schema to the fetcher's `DecoderFunction<T>` contract, so a
 * migrated module can define its shapes as Zod schemas while keeping the same
 * decoder exports its consumers and the fetcher already speak.
 *
 * The returned decoder throws on invalid input (a `ZodError`).
 */
export function zodDecoder<Schema extends z.ZodType>(
  schema: Schema,
): DecoderFunction<z.infer<Schema>> {
  return (value: unknown) => schema.parse(value);
}

/**
 * Decoder for endpoints whose response body is JSON `null`.
 */
export const nullDecoder = zodDecoder(z.null());

/**
 * Decoder for endpoints whose response body is a bare JSON string.
 */
export const stringDecoder = zodDecoder(z.string());
